var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"body-class":"pb-50"}},[_c('h6',[_vm._v("Product Trends by Month")]),_c('vue-apex-charts',{attrs:{"height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }